export default __webpack_public_path__ + "static/media/pantry1-afterI-2048w.4aece896.png";